/*
 * eros-fulfillment-swipe.js — cart fulfillment swipe bar.
 *
 * Pixel port of the Flutter ErosGlassFulfillmentSwipeBar. Right = delivery
 * (always); left = gift OR nothing, per window.ErosCheckout.leftMode().
 *
 * MOBILE (touch / no-hover): drag the thumb — past 82% of travel commits.
 * DESKTOP (hover + fine pointer): click a side — no swipe (owner spec).
 *
 * On commit it calls window.ErosCheckout.open(mode) with 'delivery' | 'gift'
 * (store pickup is closed, ADR-243). Progressive enhancement: it hides a fallback [data-eros-checkout-
 * trigger] button, which still works if this script never runs.
 */
(function () {
  'use strict';

  var THUMB = 46;
  var THUMB_H = 42;
  var THRESHOLD = 0.82;
  var ACTIVE_AT = 0.28;
  var SINGLE_LEFT = 16;
  var SINGLE_END = 8;

  // Material icon paths (24x24), matching the Flutter glyphs.
  var ICON = {
    swap: 'M6.99 11 3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z',
    truck: 'M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9L21.46 12H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z',
    gift: 'M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z',
    chevronLeft: 'M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z',
    chevronRight: 'M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'
  };

  function svg(path, cls) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('class', cls);
    s.setAttribute('fill', 'currentColor');
    s.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', path);
    s.appendChild(p);
    return s;
  }

  // Labels mirror the app's ARB strings (cartSwipe{Delivery,Gift}Prompt).
  // Desktop is click-not-swipe (owner spec), so it uses the shorter tap wording.
  var STR = {
    ar: {
      swipeDelivery: 'اسحب للتوصيل', swipeGift: 'اسحب لإرسالها هدية',
      tapDelivery: 'التوصيل', tapGift: 'إرسال كهدية'
    },
    en: {
      swipeDelivery: 'Swipe for delivery', swipeGift: 'Swipe to send as a gift',
      tapDelivery: 'Delivery', tapGift: 'Send as a gift'
    },
    ku: {
      swipeDelivery: 'بکێشە بۆ گەیاندن', swipeGift: 'بکێشە بۆ ناردنی وەک دیاری',
      tapDelivery: 'گەیاندن', tapGift: 'ناردن وەک دیاری'
    }
  };

  function strings() {
    var lang = (document.documentElement.getAttribute('lang') || 'ar').slice(0, 2).toLowerCase();
    return STR[lang] || STR.ar;
  }

  function isTouch() {
    if (window.matchMedia) {
      return window.matchMedia('(hover: none), (pointer: coarse)').matches;
    }
    return 'ontouchstart' in window;
  }

  function leftMode() {
    if (window.ErosCheckout && typeof window.ErosCheckout.leftMode === 'function') {
      return window.ErosCheckout.leftMode();
    }
    var s = (window.themeVariables || {}).settings || {};
    if (s.giftSendEnabled) return 'gift';
    return 'none';
  }

  function open(mode) {
    if (window.ErosCheckout && typeof window.ErosCheckout.open === 'function') {
      window.ErosCheckout.open(mode);
    }
  }

  function enhance(host) {
    if (host.__erosFswipe) return;
    host.__erosFswipe = true;

    // Progressive enhancement: hide the plain checkout button we replace.
    var form = host.closest ? host.closest('form, .cart-drawer__footer, .cart-footer') : null;
    var fb = (form || document).querySelector('[data-eros-fswipe-fallback]');
    if (fb) fb.style.display = 'none';

    var mode = leftMode();
    var hasAlt = mode !== 'none';
    var touch = isTouch();

    var S = strings();
    var deliveryLabel = touch ? S.swipeDelivery : S.tapDelivery;
    var altLabel = touch ? S.swipeGift : S.tapGift;

    host.textContent = '';
    host.classList.add('eros-fswipe');
    host.classList.toggle('eros-fswipe--single', !hasAlt);
    host.classList.toggle('eros-fswipe--desktop', !touch);
    host.setAttribute('role', 'group');

    // Left prompt (only when a left option is active).
    var leftPrompt = null;
    if (hasAlt) {
      leftPrompt = document.createElement('div');
      leftPrompt.className = 'eros-fswipe__prompt eros-fswipe__prompt--left';
      leftPrompt.appendChild(svg(ICON.chevronLeft, 'eros-fswipe__prompt-arrow'));
      leftPrompt.appendChild(svg(ICON.gift, 'eros-fswipe__prompt-ico'));
      var lspan = document.createElement('span');
      lspan.className = 'eros-fswipe__prompt-label';
      lspan.textContent = altLabel;
      leftPrompt.appendChild(lspan);
      host.appendChild(leftPrompt);
    }

    // Delivery prompt (right, or full-width in single mode).
    var rightPrompt = document.createElement('div');
    rightPrompt.className = 'eros-fswipe__prompt eros-fswipe__prompt--right';
    var rspan = document.createElement('span');
    rspan.className = 'eros-fswipe__prompt-label';
    rspan.textContent = deliveryLabel;
    rightPrompt.appendChild(rspan);
    rightPrompt.appendChild(svg(ICON.truck, 'eros-fswipe__prompt-ico'));
    rightPrompt.appendChild(svg(ICON.chevronRight, 'eros-fswipe__prompt-arrow'));
    host.appendChild(rightPrompt);

    // Desktop click zones (no swipe).
    if (!touch) {
      if (hasAlt) {
        var zoneL = document.createElement('div');
        zoneL.className = 'eros-fswipe__zone eros-fswipe__zone--left';
        zoneL.addEventListener('click', function () { open(mode); });
        host.appendChild(zoneL);
      }
      var zoneR = document.createElement('div');
      zoneR.className = 'eros-fswipe__zone eros-fswipe__zone--right';
      zoneR.addEventListener('click', function () { open('delivery'); });
      host.appendChild(zoneR);
    }

    // Thumb.
    var thumb = document.createElement('div');
    thumb.className = 'eros-fswipe__thumb';
    var thumbIco = svg(ICON.swap, 'eros-fswipe__thumb-ico');
    thumb.appendChild(thumbIco);
    host.appendChild(thumb);

    // ---- geometry ----
    function trackWidth() { return host.clientWidth; }
    function maxTravel() {
      var w = trackWidth();
      return hasAlt
        ? Math.max(0, (w - THUMB) / 2)
        : Math.max(0, w - THUMB - SINGLE_LEFT - SINGLE_END);
    }
    function restLeft() {
      return hasAlt ? Math.max(0, trackWidth() / 2 - THUMB / 2) : SINGLE_LEFT;
    }

    function layoutIdle() {
      thumb.style.left = restLeft() + 'px';
      thumb.style.transform = '';
      if (!touch) return; // desktop: no nudge, static thumb
      thumb.classList.add('eros-fswipe__thumb--idle');
    }

    function setActive(offset, mt) {
      var deliveryActive = offset > mt * ACTIVE_AT;
      var altActive = hasAlt && offset < -mt * ACTIVE_AT;
      thumb.classList.toggle('is-active', deliveryActive || altActive);
      // swap glyph on the thumb like Flutter (_Thumb): delivery/alt/idle
      thumbIco.firstChild.setAttribute('d',
        deliveryActive ? ICON.truck : (altActive ? ICON.gift : ICON.swap));
      if (leftPrompt) leftPrompt.classList.toggle('is-active', altActive);
      rightPrompt.classList.toggle('is-active', deliveryActive);
    }

    layoutIdle();

    // ---- desktop stops here (click-only) ----
    if (!touch) return;

    // ---- mobile drag ----
    var dragging = false;
    var committing = false;
    var startX = 0;
    var offset = 0;
    var mt = 0;
    var base = 0;

    function applyOffset() {
      thumb.style.left = base + 'px';
      thumb.style.transform = 'translateX(' + offset + 'px)';
      setActive(offset, mt);
    }

    function onDown(e) {
      if (committing) return;
      dragging = true;
      mt = maxTravel();
      base = restLeft();
      offset = 0;
      startX = e.clientX;
      thumb.classList.remove('eros-fswipe__thumb--idle');
      thumb.style.transition = 'none';
      if (host.setPointerCapture && e.pointerId != null) {
        try { host.setPointerCapture(e.pointerId); } catch (err) {}
      }
    }

    function onMove(e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      var next = dx;
      if (!hasAlt && next < 0) next = 0;
      var lo = hasAlt ? -mt : 0;
      offset = Math.max(lo, Math.min(mt, next));
      applyOffset();
    }

    function commit(mode2, target) {
      committing = true;
      dragging = false;
      thumb.style.transition = 'transform 140ms ease';
      offset = target;
      applyOffset();
      if (window.navigator && window.navigator.vibrate) {
        try { window.navigator.vibrate(10); } catch (e) {}
      }
      window.setTimeout(function () {
        open(mode2);
        // reset
        thumb.style.transition = 'transform 160ms ease';
        offset = 0;
        thumb.style.transform = 'translateX(0)';
        setActive(0, mt);
        window.setTimeout(function () {
          committing = false;
          thumb.style.transition = '';
          layoutIdle();
        }, 180);
      }, 140);
    }

    function onUp() {
      if (!dragging) return;
      dragging = false;
      if (mt <= 0) { offset = 0; applyOffset(); layoutIdle(); return; }
      var ratio = offset / mt;
      if (ratio >= THRESHOLD) {
        commit('delivery', mt);
        return;
      }
      if (hasAlt && ratio <= -THRESHOLD) {
        commit(mode, -mt);
        return;
      }
      // snap back
      thumb.style.transition = 'transform 160ms ease';
      offset = 0;
      thumb.style.transform = 'translateX(0)';
      setActive(0, mt);
      window.setTimeout(function () {
        thumb.style.transition = '';
        layoutIdle();
      }, 180);
    }

    if (window.PointerEvent) {
      host.addEventListener('pointerdown', onDown);
      host.addEventListener('pointermove', onMove);
      host.addEventListener('pointerup', onUp);
      host.addEventListener('pointercancel', onUp);
    } else {
      host.addEventListener('touchstart', function (e) { onDown(e.touches[0]); }, { passive: true });
      host.addEventListener('touchmove', function (e) { onMove(e.touches[0]); }, { passive: true });
      host.addEventListener('touchend', onUp);
    }

    // Re-center on resize (drawer open / orientation change).
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { if (!dragging && !committing) layoutIdle(); });
      ro.observe(host);
    } else {
      window.addEventListener('resize', function () { if (!dragging && !committing) layoutIdle(); });
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-eros-fswipe]');
    for (var i = 0; i < nodes.length; i++) enhance(nodes[i]);
  }

  function boot() {
    scan(document);
    // The cart drawer re-renders its footer on cart updates; re-scan then.
    document.addEventListener('cart:refresh', function () { window.setTimeout(function () { scan(document); }, 0); });
    // Enhance any swipe bar that appears later (drawer opened, section reload).
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { scan(document); return; }
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.ErosFulfillmentSwipe = { scan: scan, enhance: enhance };
})();
